interface CacheOpts {
  lifetime: number;
}

interface CacheEntry {
  insertedAt: number;
  expiresAt: number;
  response: any;
}

export class StaleWhileRevalidateCache {
  private cache = new Map<string, CacheEntry>();

  public async get(
    endpoint: URL,
    executor: <T>(url: URL) => Promise<T>,
    opts: CacheOpts = { lifetime: 60 * 1000 },
  ) {
    const cachedResponse = this.cache.get(endpoint.href);

    if (!cachedResponse || !this.isValid(cachedResponse)) {
      return await this.upsertCacheEntry(endpoint, executor, opts);
    }

    this.refreshInBackground(endpoint, executor, opts);

    return cachedResponse.response;
  }

  private isValid(entry: CacheEntry) {
    return Date.now() < entry.expiresAt;
  }

  private async upsertCacheEntry(
    endpoint: URL,
    executor: <T>(url: URL) => Promise<T>,
    opts: CacheOpts,
  ) {
    const response = await executor<ResponseType>(endpoint);
    this.addCacheEntry(endpoint, response, opts);
    return response;
  }

  private addCacheEntry<T>(endpoint: URL, response: T, opts: CacheOpts) {
    this.cache.set(endpoint.href, {
      insertedAt: Date.now(),
      expiresAt: Date.now() + opts.lifetime,
      response,
    });
  }

  private refreshInBackground(
    endpoint: URL,
    executor: <T>(url: URL) => Promise<T>,
    opts: CacheOpts,
  ) {
    executor(endpoint)
      .then((refreshedResponse) => {
        this.addCacheEntry(endpoint, refreshedResponse, opts);
      })
      .catch(console.error);
  }
}
